import { IWebsiteBuilderEditorHistoryActionBase, IWebsiteBuilderHistorySnapshot, WebsiteBuilderEditorActionType } from "../../websiteBuilderEditorAction";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { cloneDeep } from "lodash";
import { IDeleteNodeAction } from "./deleteNode";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { IWebsiteBuilderNodeLifecycleSnapshot } from "../../actionHelpers/nodeLifecycleSnapshot";
import { IWebsiteBuilderGeneralTraversalNode } from "../../actionHelpers/generalTraversal";

export interface IAddNodeActionPayload {
  snapshot: IWebsiteBuilderNodeLifecycleSnapshot;
}

export interface IAddNodeAction extends IWebsiteBuilderEditorHistoryActionBase {
  type: typeof WebsiteBuilderEditorActionType.ADD_NODE;
  payload: IAddNodeActionPayload;
}

export function getAddNodeInverseAction(action: IAddNodeAction): IDeleteNodeAction {
  const { snapshot } = action.payload;

  return {
    type: WebsiteBuilderEditorActionType.DELETE_NODE,
    pageId: action.pageId,
    device: action.device,
    scrollNodeId: snapshot.inverseScrollNodeId,
    payload: {
      snapshot: cloneDeep(snapshot),
    },
  };
}

function addNodeTraversal(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  snapshot: IWebsiteBuilderNodeLifecycleSnapshot,
): IWebsiteBuilderHistorySnapshot {
  function traverse(node: IWebsiteBuilderGeneralTraversalNode): IWebsiteBuilderGeneralTraversalNode {
    if (!node.children) {
      return node;
    } else {
      let updatedChildren = node.children;

      if (snapshot.parentId === node.id) {
        updatedChildren = [
          ...updatedChildren.slice(0, snapshot.index),
          snapshot.node,
          ...updatedChildren.slice(snapshot.index),
        ];
      }

      return {
        ...node,
        children: updatedChildren.map(traverse),
      };
    }
  }

  return {
    header: traverse(header) as IWebsiteBuilderHeader,
    root: traverse(root) as IWebsiteBuilderRoot,
    footer: traverse(footer) as IWebsiteBuilderFooter,
  };
}

export function applyAddNodeChange(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  action: IAddNodeAction,
): IWebsiteBuilderHistorySnapshot {
  const { snapshot } = action.payload;

  if (
    snapshot.node.type === "root" ||
    snapshot.parentId == null ||
    (snapshot.node.type === "section" && snapshot.node.section.type === "header") ||
    (snapshot.node.type === "section" && snapshot.node.section.type === "footer")
  ) {
    return { header, root, footer };
  }

  return addNodeTraversal(header, root, footer, cloneDeep(snapshot));
}
